import AppModules from '../../../core/app-modules';
import { useCarrierPortalGlobalStore } from '../../../stores/carrier-portal-global-store';
import Loader from '../../../common/loader';
import { IRoute } from '../../../models/routes.interface';
import Breadcrumbs from '../../../common/bread-crump/bread-crumb';
import './body.scss';

export default function Body() {
  const [selectedMenu] = useCarrierPortalGlobalStore(
    store => store.menu.selectedMenu
  );
  const [isLoading] = useCarrierPortalGlobalStore(
    store => store.menu.isLoading
  );

  const routes: IRoute[] = Array.isArray(selectedMenu)
    ? (selectedMenu as IRoute[])
    : [];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Breadcrumbs />
          <div className="grc-card-body">{<AppModules routes={routes} />}</div>
        </>
      )}
    </>
  );
}
